import { useState, useEffect, useContext } from "react";
import {
  Configurations,otherConfigOptionsAttributesFeature} from "../configSetupScreen/widget/configBottomBar";
import * as Sentry from "@sentry/react";
import { PlaygroundConfigValueContext } from "../../../../components/newPortal/NewPortalLayout";
import { openPopup as triggerPopUp } from "../../../../stateManagement/actions/popupActions";
import { popupType } from "../../../../types/types";
import { mapUiSchemaToType } from "../../../../services/uiConfigService";
import ConfigButtons from "../components/configButtons";
import { Loader } from "../../../../components/loader/Loader";
import { usePopup } from "../../../../components/newPortal/PopUpContext";
import { StudioRoleSelectionAndSavePopupModal } from "../../../../components/newPortal/components/studioRoleSelectionAndSavePopupModal";
import { useSelector } from "react-redux";
import store from "../../../../stateManagement/store";
import { Typography } from "@mui/material";
import { GenericUIComponentNew } from "../../../../components/uiConfig/GenericUiComponentNew";
import CustomComponentMapping from "./CustomComponentMapping";
import { ServiceHandler } from "../../../../components/newPortal/Service/Factory/ServiceFactory";
import { UiConfigService } from "../../../../components/newPortal/Service/serviceshandler/UiConfigService";

interface Props {
  subFeature?: otherConfigOptionsAttributesFeature;
  areDataFieldsValid: boolean;
  setAreDataFieldsValid: (isValid: boolean) => void;
  preview: number;
  service: ServiceHandler;
}

const GenericComponentConfig = (props: Props) => {
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [isSpinning, setIsSpinning] = useState(false);
  const [valueArray, setValueArray] = useState<any[]>([]);
  const [values, setValues] = useState<any>({});
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [extraValues, setExtraValues] = useState<any>({});
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");
  const { showPopup } = usePopup();
  const savedRole: any = useSelector(() => store.getState().roleState.role);
  const [loading, setLoading] = useState(true);
  const savedAppType: any = useSelector(
    () => store.getState().appTypeState.appType
  );
  const [hasActiveChild, setHasActiveChild] = useState(true);
  const PlaygroundConfigContext = useContext(PlaygroundConfigValueContext);
  const openPopup = (message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  };
  const domainMapping = props.subFeature?.domainMapping ?? props.subFeature?.configuration??{};
  const {
    playgroundConfiguration,
    setPlayGroundConfiguration,
    onTriggerConfigChanges,
    keyValue,
    setKeyValue,
    setCleanSyncDataLoaderIds,
  } = PlaygroundConfigContext ?? {
    playgroundConfiguration: [],
    setPlayGroundConfiguration: () => {},
    onTriggerConfigChanges: () => {},
    setKeyValue: () => {},
    keyValue: 0,
    setCleanSyncDataLoaderIds: () => {},
  };

  useEffect(() => {
    if (props.preview > 0) handlePreview();
  }, [props.preview]);

  const init = async () => {
    try {
      setLoading(true);
      const data = await props.service.getData?.(savedRole);
      setValues(data);
    } catch (error) {
      console.error("Error in fetching the config", error);
      triggerPopUp("Error", "Error in fetching the config", () => {});
    } finally {
      setLoading(false);
    }
  };
const canSave = props?.service?.validateBeforeSave?props.service?.validateBeforeSave?.(values)?.isValid &&props.areDataFieldsValid:props.areDataFieldsValid
  const handleReset = () => {
    init();
  };
  const handlePreview = async () => {
    try {
      setIsSpinning(true);
      await props.service.handlePreview?.(
        setPlayGroundConfiguration,
        setKeyValue,
        keyValue,
        props.subFeature,
        setCleanSyncDataLoaderIds,
        values
      );
    } catch (error) {
      console.error("Error in onTriggerConfigChanges:", error);
    }
    setTimeout(() => {
      setIsSpinning(false);
    }, 1000);
  };

  const handleSave = async (preview?: boolean) => {
    try {
      await props.service.SaveData?.(values);
      if (props.service?.requiresStudioSavePopup) {
        showPopup((close) => (
          <StudioRoleSelectionAndSavePopupModal
            inputData={{
              requiredConfigsMap: domainMapping,
              initialConfigMap: props.service.initialConfigMap ?? {},
              updatedConfigMap: props.service.updatedConfigMap ?? {},
              appType: savedAppType,
              role: savedRole,
            }}
            onCancel={close}
            actionPostSuccess={init}
          />
        ));
      } else {
         console.log("showing success popup");
        triggerPopUp( "Success", "Configuration Updated");
      }
    } catch (err) {
      console.log("error block")
      Sentry.captureException(err);
      console.log("err===", err);
      if (err instanceof Error)
        openPopup("Validation Error occured : " + err?.message, "Error");
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const val = await props.service.setDefaultValues?.(domainMapping);
        setDefaultValues(val);
      } catch (err) {
        console.error("Error in fetching default Config:", err);
      } finally {
        setLoading(false);
      }
    };
    if (props.service?.setDefaultValues) fetchData();
  }, []);

  useEffect(() => {
    if (!props.service.defaultValues || Object.keys(defaultValues).length !== 0)
      init();
  }, [defaultValues]);

  useEffect(() => {
    if (
      props.service.dependsOnRole &&
      props.service instanceof UiConfigService &&
      Object.keys(defaultValues).length != 0
    ) {
      const val = props.service.setupConfigState(savedRole);
      setValues(val);
    }
  }, [savedRole]);

  useEffect(() => {
    if (values) setValueArray(Object.values(values ?? {}));
  }, [values]);

  return (
    <div className=" config-container-left">
      <div className="config-main-logic-container">
        {loading || valueArray.length === 0 ? (
          <Loader />
        ) : (
          <div className="config-main">
            {Object.entries(
              props?.subFeature?.configuration?.reduce(
                (
                  acc: Record<string, Configurations[]>,
                  item: Configurations
                ) => {
                  const section = item.section || "General";
                  acc[section] = acc[section] || [];
                  acc[section].push(item);
                  return acc;
                },
                {}
              ) ?? {}
            ).map(([sectionName, items]) => (
              <div key={sectionName} style={{ textAlign: "left" }}>
                <div
                  style={{
                    backgroundColor: "#F5F5F7",
                    padding: "12px",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                >
                  <Typography sx={{ fontWeight: "600" }}>
                    {sectionName}
                  </Typography>
                </div>
                <div style={{ margin: "12px 16px 12px 12px" }}>
                  {items.map((item: any) => {
                    const matched = valueArray.find(
                      (val: any) => val[props.service.key] === item.name
                    );
                    if (!matched || item.uiSchema.config === "custom") {
                      const Comp = CustomComponentMapping({
                        values,
                        setValues,
                        name: `${props?.subFeature?.id
                          .replace(/\s+/g, "")
                          .toLowerCase()}_${item.name
                          .replace(/\s+/g, "")
                          .toLowerCase()}`,
                        extraValues,
                        setExtraValues,
                        defaultValues,
                        setAreDataFieldsValid: props.setAreDataFieldsValid,
                      });
                      return (
                        Comp && (
                          <div
                            style={{
                              padding: "8px",
                              borderRadius: "8px",
                              backgroundColor: "#f8fafc",
                              marginBottom: "10px",
                            }}
                          >
                            {Comp}
                          </div>
                        )
                      );
                    }
                    if (item.uiSchema?.dependsOn) {
                      const dependancy = item.uiSchema?.dependsOn;
                      for (let field in dependancy) {
                        if (values?.[field]?.value !== dependancy[field]) {
                          return null;
                        }
                      }
                    }

                    return (
                      <GenericUIComponentNew
                        key={matched.name}
                        sx={{
                          minWidth: "50%",
                          borderRadius: "8px",
                          padding: "8px",
                          marginBottom: "10px",
                          backgroundColor: "#f8fafc",
                          display:
                            item.uiSchema.displayType === "toggle"
                              ? "flex"
                              : undefined,
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        heading={item.uiSchema.question}
                        type={mapUiSchemaToType(
                          item.uiSchema.displayType?.toLowerCase() ?? ""
                        )}
                        values={values}
                        setValues={setValues}
                        name={matched.name}
                        validations={item?.uiSchema?.validations ?? {}}
                        setAreDataFieldsValid={props.setAreDataFieldsValid}
                        description={item?.uiSchema?.description ?? ""}
                        updateState={props.service.updateState}
                      />
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        )}
        {!loading && valueArray.length > 0 && (
          <ConfigButtons
            areDataFieldsValid={!!canSave}
            hasActiveChild={hasActiveChild}
            handleSave={handleSave}
            handleReset={handleReset}
            isSpinning={isSpinning}
            setIsSpinning={setIsSpinning}
          />
        )}
      </div>
    </div>
  );
};
export default GenericComponentConfig;
